module.exports = __webpack_public_path__ + "static/media/id.ce72edd2.svg";